<script setup>
import { provide, ref, onMounted } from 'vue';
import AccountSidebar from '@components/accountSidebar/accountSidebar.vue';
import Loader from '@components/loader.vue';
import { __, requestAccountSession } from '@/utils';

const features = {
    tracking: false,
    lastInvoice: false,
    recentMessages: false,
    packageAbroad: false,
    packageChange: false,
    accountEdit: true,
    paymentEdit: true,
}

const details = ref({})

const setUpdatedDetails = (details) => {
    details.value = details
};

const fetchAccountSession = async () => {
    let [data, error] = await requestAccountSession();

    if(error) {
        console.error(error);
    } else {
        if(data) {
            details.value = data.data ?? {};
        }
    }
};

onMounted(() => {
    fetchAccountSession();
});

provide('account', {
    features,
    details: details,
    setUpdatedDetails,
});
</script>

<template>
    <div class="account-container" v-if="details.id">
        <AccountSidebar />
        <RouterView />
    </div>
    <div class="loader-container"  v-if="!details.id">
        <Loader color="#2563eb" />
    </div>
</template>